
import { tx, lz } from "@/i18n";const SES_STYLES = [
  "bg-red-100 text-red-700 border-red-300 hover:bg-red-200",
  "bg-amber-100 text-amber-800 border-amber-300 hover:bg-amber-200",
  "bg-emerald-100 text-emerald-700 border-emerald-300 hover:bg-emerald-200",
];
const SES_TITLES = lz([
  "SES: niets gedaan",
  "SES: reservering aangemeld",
  "SES: gasten aangemeld",
]);

export const SesButton = ({ status = 0, canEdit = false, onCycle, testId }) => {
  const s = Math.max(0, Math.min(2, status || 0));
  return (
    <button
      type="button"
      disabled={!canEdit}
      onClick={canEdit ? onCycle : undefined}
      title={SES_TITLES[s]}
      aria-label={SES_TITLES[s]}
      className={`text-xs font-bold px-2.5 py-1 rounded-full border transition-colors ${SES_STYLES[s]} ${canEdit ? "cursor-pointer" : "cursor-default"}`}
      data-testid={testId}
    >
      SES
    </button>
  );
};
